// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/pmStatus.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9659: ONE PM brain — Maintenance fleet grid, connector, in-app assistant.)
//
// Side-effect module: attaches `window.PmStatus`. maintenance.js and
// pretrip.js read it at CALL time.
//
// The body below is the canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================
(function () {
  'use strict';

  var PM_BUILTIN_INTERVALS = { truck: 15000, _default: 5000, _hours: 250 };

  var PM_RULES = {
    milesPerDay: 1500,      // no truck covers more in a day (team driving ~1,300)
    hoursPerDay: 24,        // an hour meter cannot run faster than the clock
    milesSlack: 1500,       // one extra day, for readings stamped on the same day
    hoursSlack: 24,
    milesBackTolerance: 50, // a reading this much lower is a rounding / copy slip, not a typo
    hoursBackTolerance: 2,
    milesCeiling: 3000000,
    hoursCeiling: 200000,
    noTimeMilesJump: 150000, // a reading with no usable timestamp: the flat cap
    noTimeHoursJump: 10000,
    dueSoonMilesFraction: 0.1,
    dueSoonHours: 25,
    screenMax: 400,         // readings screened per meter (the newest, ~a year of daily DVIRs); older ones are history.
                            // The chain is O(n^2): 400 keeps a 50-truck grid render well under a second.
    meterChangeMin: 5       // readings a newer, self-consistent run needs to count as a replaced meter
  };

  var PM_DAY_MS = 86400000;

  /** A meter value: finite and > 0, else null (0 / '' / null = no reading). */
  function pmNum(v) {
    if (v === null || v === undefined || v === '' || typeof v === 'boolean') return null;
    var n = typeof v === 'number' ? v : Number(String(v).replace(/,/g, '').trim());
    return Number.isFinite(n) && n > 0 ? n : null;
  }

  /** Epoch ms of a metersLog row (`ts` or `timestamp`: Firestore Timestamp, Date, ISO string, ms, {_seconds}). 0 = unknown. */
  function pmEntryTimeMs(entry) {
    var t = entry && (entry.ts || entry.timestamp);
    if (!t) return 0;
    try {
      if (typeof t.toMillis === 'function') return t.toMillis();
      if (typeof t.toDate === 'function') { var d = t.toDate(); return d && Number.isFinite(d.getTime()) ? d.getTime() : 0; }
      if (t instanceof Date) return Number.isFinite(t.getTime()) ? t.getTime() : 0;
      if (typeof t === 'number') return Number.isFinite(t) ? t : 0;
      if (typeof t === 'object' && typeof t._seconds === 'number') return t._seconds * 1000;
      var n = new Date(t).getTime();
      return Number.isFinite(n) ? n : 0;
    } catch (_) { return 0; }
  }

  /** The tenant's intervals: saved settings.pmIntervals over the built-ins. */
  function pmMergeIntervals(stored) {
    var out = {};
    var k;
    for (k in PM_BUILTIN_INTERVALS) out[k] = PM_BUILTIN_INTERVALS[k];
    if (stored && typeof stored === 'object' && !Array.isArray(stored)) {
      for (k in stored) if (Object.prototype.hasOwnProperty.call(stored, k)) out[k] = stored[k];
    }
    return out;
  }

  function pmPositive(v) {
    var n = Number(v);
    return v !== null && v !== undefined && v !== '' && Number.isFinite(n) && n > 0 ? n : null;
  }

  /**
   * Which interval a vehicle runs on, and where it came from.
   * `stored` = tenant settings.pmIntervals AS SAVED (null/undefined = never saved).
   */
  function pmResolveIntervals(vehicle, stored) {
    var st = stored && typeof stored === 'object' && !Array.isArray(stored) ? stored : {};
    var pm = pmMergeIntervals(st);
    var slug = String((vehicle && vehicle.type) || '').toLowerCase();
    var milesInterval;
    var milesIntervalSource;
    var milesIntervalKey;
    if (slug && pmPositive(pm[slug]) !== null) {
      milesInterval = pmPositive(pm[slug]);
      milesIntervalKey = slug;
      milesIntervalSource = st[slug] != null ? 'set' : 'default';
    } else {
      milesInterval = pmPositive(pm._default);
      milesIntervalKey = '_default';
      milesIntervalSource = st._default != null && pmPositive(st._default) !== null ? 'set' : 'default';
      if (milesInterval === null) { milesInterval = PM_BUILTIN_INTERVALS._default; milesIntervalSource = 'default'; }
    }
    var hoursInterval = pmPositive(pm._hours);
    var hoursIntervalSource = st._hours != null && pmPositive(st._hours) !== null ? 'set' : 'default';
    if (hoursInterval === null) { hoursInterval = PM_BUILTIN_INTERVALS._hours; hoursIntervalSource = 'default'; }
    return {
      typeSlug: slug,
      milesInterval: milesInterval,
      milesIntervalSource: milesIntervalSource,
      milesIntervalKey: milesIntervalKey,
      hoursInterval: hoursInterval,
      hoursIntervalSource: hoursIntervalSource
    };
  }

  /** One vehicle's metersLog rows, NEWEST first: by id (truckId / assetId), else by unit name. */
  function pmRowsForVehicle(metersLog, vehicle) {
    var list = Array.isArray(metersLog) ? metersLog : [];
    var id = vehicle && vehicle.id;
    var rows = list.filter(function (m) { return m && id != null && (m.truckId === id || m.assetId === id); });
    var unitLower = String((vehicle && vehicle.unit) || '').toLowerCase();
    if (rows.length === 0 && unitLower) {
      rows = list.filter(function (m) {
        return m && (String(m.truckUnit || '').toLowerCase() === unitLower || String(m.assetName || '').toLowerCase() === unitLower);
      });
    }
    var withT = rows.map(function (r, i) { return { r: r, t: pmEntryTimeMs(r), i: i }; });
    withT.sort(function (a, b) { return (b.t - a.t) || (a.i - b.i); });
    return withT.map(function (x) { return x.r; });
  }

  // Only the explicit confirmation counts. The legacy correctMeters endpoint's
  // source 'manual_override' does NOT: live data has wrong override rows (a 500-hr
  // "correction" on an 18,900-hr truck) that would otherwise outrank everything after.
  function pmIsConfirmed(row) {
    return !!row && row.meterConfirmed === true;
  }

  /**
   * Why `next` cannot follow `from` on this meter, or null when it can.
   * from/next = { value, atMs }.
   */
  function pmStepProblem(meter, from, next) {
    var R = PM_RULES;
    var isMiles = meter === 'miles';
    var ceiling = isMiles ? R.milesCeiling : R.hoursCeiling;
    if (next.value > ceiling) return { kind: 'ceiling', allowed: ceiling };
    if (!from) return null;
    var tol = isMiles ? R.milesBackTolerance : R.hoursBackTolerance;
    if (next.value < from.value - tol) return { kind: 'backwards', allowed: from.value };
    var gain = next.value - from.value;
    var allowed;
    if (from.atMs > 0 && next.atMs > 0) {
      var days = Math.max(0, (next.atMs - from.atMs) / PM_DAY_MS);
      allowed = isMiles ? R.milesPerDay * days + R.milesSlack : R.hoursPerDay * days + R.hoursSlack;
    } else {
      allowed = isMiles ? R.noTimeMilesJump : R.noTimeHoursJump;
    }
    if (gain > allowed) return { kind: 'jump', allowed: Math.floor(allowed) };
    return null;
  }

  /**
   * The longest run of readings (oldest -> newest, indices into `seg`) in which
   * every step is plausible. `forced` = the chain must start at seg[0].
   * Ties go to the chain ending newest. Returns { on: {index: true}, last }.
   */
  function pmLongestChain(meter, seg, forced) {
    var n = seg.length;
    var len = [];
    var prev = [];
    for (var i = 0; i < n; i++) {
      len[i] = 0;
      prev[i] = -1;
      if (pmStepProblem(meter, null, seg[i])) continue; // past the ceiling: never believable
      len[i] = forced && i > 0 ? 0 : 1;
      if (forced && i === 0) continue;
      for (var j = 0; j < i; j++) {
        if (len[j] === 0 || len[j] + 1 < len[i]) continue;
        if (!pmStepProblem(meter, seg[j], seg[i])) { len[i] = len[j] + 1; prev[i] = j; }
      }
    }
    var best = -1;
    for (var k = 0; k < n; k++) if (len[k] > 0 && (best < 0 || len[k] >= len[best])) best = k;
    var on = {};
    for (var q = best; q >= 0; q = prev[q]) on[q] = true;
    return { on: on, last: best };
  }

  /**
   * Screen one meter ('miles' | 'hours') across rows (any order).
   *
   * The believable readings are the LONGEST chain of readings in which every
   * step is one a vehicle can make (pmStepProblem: not backwards, not faster
   * than the clock allows, under the ceiling). Everything off that chain is
   * suspect. A run of the same typo (a dropped decimal point copied onto the
   * next three DVIRs) is a short chain beside the real one, so it is left out;
   * a wrong FIRST reading or a wrong old manual entry is outvoted the same way.
   * Ties go to the chain whose last reading is newest.
   *
   * A reading the user CONFIRMED (meterConfirmed: true) restarts the chain: readings before the newest confirmed
   * one are history and are not used or flagged (a replaced meter is fixed by
   * confirming its first new reading).
   *
   * Returns { items, anchor, restarted, keepItem } — items oldest -> newest, each
   * { row, value, atMs, suspect, kind?, against? }; `anchor` = the newest
   * believable reading a new one is checked against (null when none).
   */
  function pmScreenMeter(rows, meter, keepRow) {
    var list = (Array.isArray(rows) ? rows : []).map(function (r, i) {
      return { row: r, value: pmNum(r && r[meter]), atMs: pmEntryTimeMs(r), i: i };
    }).filter(function (x) { return x.value !== null; });
    list.sort(function (a, b) { return (a.atMs - b.atMs) || (b.i - a.i); });
    var start = 0;
    var forced = false;
    for (var c = list.length - 1; c >= 0; c--) {
      if (pmIsConfirmed(list[c].row) && !pmStepProblem(meter, null, list[c])) {
        // The confirmation is for the ROW; a meter on it that already fits the
        // history before it is just a reading — only a meter that does NOT fit
        // restarts (confirming a replaced hour meter must not cut the odometer off
        // from its last PM).
        var before = list.slice(Math.max(0, c - PM_RULES.screenMax), c);
        var bc = pmLongestChain(meter, before, false);
        if (bc.last >= 0 && !pmStepProblem(meter, before[bc.last], list[c])) break;
        start = c; forced = true; break;
      }
    }
    var restarted = forced;
    var capped = false;
    if (list.length - start > PM_RULES.screenMax) { start = list.length - PM_RULES.screenMax; forced = false; restarted = false; capped = true; }
    var seg = list.slice(start);
    var ch = pmLongestChain(meter, seg, forced);
    // A meter change: the readings AFTER the chain's last one carry their own
    // chain (>= 5 readings, >= 3 distinct values, over >= 7 days) that the old
    // history cannot reach. The newer meter wins; what came before is history.
    for (var guard = 0; guard < 3 && ch.last >= 0; guard++) {
      var tail = seg.slice(ch.last + 1);
      if (tail.length < PM_RULES.meterChangeMin) break;
      var tc = pmLongestChain(meter, tail, false);
      var idx = Object.keys(tc.on).map(Number).sort(function (a2, b2) { return a2 - b2; });
      if (idx.length < PM_RULES.meterChangeMin) break;
      var distinct = {};
      idx.forEach(function (ix) { distinct[tail[ix].value] = true; });
      var first = tail[idx[0]];
      var lastT = tail[idx[idx.length - 1]];
      if (Object.keys(distinct).length < 3 || !(first.atMs > 0) || lastT.atMs - first.atMs < 7 * PM_DAY_MS) break;
      seg = tail.slice(idx[0]);
      forced = true;
      restarted = true;
      ch = pmLongestChain(meter, seg, true);
    }
    var n = seg.length;
    var onChain = ch.on;
    var tolB = meter === 'miles' ? PM_RULES.milesBackTolerance : PM_RULES.hoursBackTolerance;
    var items = [];
    var anchor = null;
    var lastChain = null;
    for (var t = 0; t < n; t++) {
      var x = seg[t];
      var item = { row: x.row, value: x.value, atMs: x.atMs, suspect: false };
      if (onChain[t]) {
        lastChain = x;
      } else {
        // Off the chain but sitting between its chain neighbours (a PM logged a
        // week late with the meter it was serviced at) is believable; anything
        // else is suspect.
        var nextChain = null;
        for (var u = t + 1; u < n; u++) if (onChain[u]) { nextChain = seg[u]; break; }
        var ceil = pmStepProblem(meter, null, x);
        var fits;
        if (ceil) fits = false;
        else if (lastChain && nextChain) fits = x.value >= lastChain.value - tolB && x.value <= nextChain.value + tolB;
        else if (lastChain) fits = !pmStepProblem(meter, lastChain, x);
        else if (nextChain) fits = !pmStepProblem(meter, x, nextChain);
        else fits = false;
        if (!fits) {
          var p = ceil || (lastChain ? pmStepProblem(meter, lastChain, x) : null);
          item.suspect = true;
          item.kind = p ? p.kind : (nextChain && x.value > nextChain.value ? 'jump' : 'backwards');
          item.against = lastChain ? { value: lastChain.value, atMs: lastChain.atMs } : (nextChain ? { value: nextChain.value, atMs: nextChain.atMs } : null);
        }
      }
      if (!item.suspect && (!anchor || item.value >= anchor.value - tolB)) anchor = { value: item.value, atMs: item.atMs };
      items.push(item);
    }
    // `keepRow` (the last PM) older than the screened window is still screened —
    // against the readings around it — so a mistyped PM never ages out of the
    // check (COD 2026-10-14). Returned as `keepItem` (null when not needed).
    var keepItem = null;
    if (keepRow && capped) {
      var inSeg = false;
      for (var w = 0; w < items.length; w++) if (items[w].row === keepRow) { inSeg = true; break; }
      var ki = -1;
      for (var z = 0; z < list.length; z++) if (list[z].row === keepRow) { ki = z; break; }
      if (!inSeg && ki >= 0) {
        var lo = Math.max(0, ki - 30);
        var local = list.slice(lo, ki + 31);
        var lc = pmLongestChain(meter, local, false);
        var me = ki - lo;
        var kx = list[ki];
        keepItem = { row: kx.row, value: kx.value, atMs: kx.atMs, suspect: false };
        if (!lc.on[me]) {
          var pv = null; var nx = null;
          for (var a1 = me - 1; a1 >= 0; a1--) if (lc.on[a1]) { pv = local[a1]; break; }
          for (var a2 = me + 1; a2 < local.length; a2++) if (lc.on[a2]) { nx = local[a2]; break; }
          var okBetween = pv && nx ? (kx.value >= pv.value - tolB && kx.value <= nx.value + tolB)
            : (pv ? !pmStepProblem(meter, pv, kx) : (nx ? !pmStepProblem(meter, kx, nx) : false));
          if (pmStepProblem(meter, null, kx) || !okBetween) {
            var kp = pmStepProblem(meter, null, kx) || (pv ? pmStepProblem(meter, pv, kx) : null);
            keepItem.suspect = true;
            keepItem.kind = kp ? kp.kind : 'jump';
            keepItem.against = pv ? { value: pv.value, atMs: pv.atMs } : null;
          }
        }
      }
    }
    return { items: items, anchor: anchor, restarted: restarted, keepItem: keepItem };
  }

  /**
   * Check a NEW reading before it is written. rows = the vehicle's metersLog rows
   * (pmRowsForVehicle), candidate = { miles, hours, atMs }.
   * Returns { ok, problems: [{ meter, kind: 'backwards'|'jump'|'ceiling', value, lastValue, lastAtMs, allowed }] }.
   */
  function pmCheckReading(rows, candidate) {
    var c = candidate || {};
    var atMs = Number.isFinite(c.atMs) && c.atMs > 0 ? c.atMs : Date.now();
    var problems = [];
    var meters = ['miles', 'hours'];
    for (var i = 0; i < meters.length; i++) {
      var meter = meters[i];
      var value = pmNum(c[meter]);
      if (value === null) continue;
      var anchor = pmScreenMeter(rows, meter).anchor;
      var p = pmStepProblem(meter, anchor, { value: value, atMs: atMs });
      if (p) {
        problems.push({
          meter: meter,
          kind: p.kind,
          value: value,
          lastValue: anchor ? anchor.value : null,
          lastAtMs: anchor ? anchor.atMs : null,
          allowed: p.allowed
        });
      }
    }
    return { ok: problems.length === 0, problems: problems };
  }

  function pmFmt(n) {
    var v = Math.round(Number(n) * 10) / 10;
    var parts = String(Math.abs(v)).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (v < 0 ? '-' : '') + parts.join('.');
  }

  /** One sentence for a check problem (the confirm dialog, the DVIR toast, the connector refusal). */
  function pmProblemText(p, label) {
    var unit = p.meter === 'miles' ? 'miles' : 'hours';
    var who = label ? ' on ' + label : '';
    if (p.kind === 'ceiling') return pmFmt(p.value) + ' ' + unit + ' is more than any vehicle reads — probably a mistyped number.';
    if (p.kind === 'backwards') return pmFmt(p.value) + ' ' + unit + ' is lower than the last reading' + who + ' (' + pmFmt(p.lastValue) + ').';
    return pmFmt(p.value) + ' ' + unit + ' is ' + pmFmt(p.value - p.lastValue) + ' more than the last reading' + who + ' (' + pmFmt(p.lastValue) + ') — more than the vehicle can run in that time, probably a mistyped number.';
  }

  /**
   * PM position of ONE vehicle.
   * @param vehicle    { id, unit, type }
   * @param metersLog  tenants/{t}/metersLog rows (any vehicles; filtered here)
   * @param stored     tenant settings.pmIntervals AS SAVED
   * Returns {
   *   status: 'overdue'|'due_soon'|'check_reading'|'unknown'|'ok', label, reason?,
   *   miles, hours: { known, current?, atLastPm?, sinceLastPm?, interval?, remaining?, why?, suspect? },
   *   suspect: [{ meter, where: 'latest'|'last_pm', value, atMs, kind, against, rowId }],
   *   suspectIgnored: number (older suspect readings left out of the math),
   *   milesInterval, milesIntervalSource, milesIntervalKey, hoursInterval, hoursIntervalSource, typeSlug,
   *   current: { miles, hours }, lastPm: { miles, hours, atMs } | null,
   *   lastPmAtMs, lastReadingAtMs, urgency,
   *   review: pmSuspectReview(...) (TASK-9898 follow-up: does the PM put it in Needs Attention)
   * }
   * Each suspect entry also carries clockMs, ifRight, plausible (pmSuspectEntry).
   * @param opts  { nowMs, timeZone (company zone), todayKey } — all optional; now = Date.now().
   */
  function pmStatusFor(vehicle, metersLog, stored, opts) {
    var o = opts || {};
    var at = { nowMs: o.nowMs !== undefined && o.nowMs !== null ? o.nowMs : Date.now(), timeZone: o.timeZone, todayKey: o.todayKey };
    var d = pmStatusCore(vehicle, metersLog, stored, at.nowMs);
    d.review = pmSuspectReview(d, at);
    return d;
  }

  function pmStatusCore(vehicle, metersLog, stored, nowMs) {
    var iv = pmResolveIntervals(vehicle, stored);
    var rows = pmRowsForVehicle(metersLog, vehicle);
    var pmRow = null;
    for (var r = 0; r < rows.length; r++) if (rows[r] && rows[r].type === 'pm') { pmRow = rows[r]; break; }
    var out = {
      typeSlug: iv.typeSlug,
      milesInterval: iv.milesInterval,
      milesIntervalSource: iv.milesIntervalSource,
      milesIntervalKey: iv.milesIntervalKey,
      hoursInterval: iv.hoursInterval,
      hoursIntervalSource: iv.hoursIntervalSource,
      lastPmAtMs: pmRow ? (pmEntryTimeMs(pmRow) || null) : null,
      lastReadingAtMs: rows.length ? (pmEntryTimeMs(rows[0]) || null) : null,
      lastPm: pmRow ? { miles: pmNum(pmRow.miles), hours: pmNum(pmRow.hours), atMs: pmEntryTimeMs(pmRow) || null } : null,
      current: { miles: null, hours: null },
      suspect: [],
      suspectIgnored: 0,
      urgency: Infinity
    };
    var dims = {};
    var meters = ['miles', 'hours'];
    for (var i = 0; i < meters.length; i++) {
      var meter = meters[i];
      var interval = meter === 'miles' ? iv.milesInterval : iv.hoursInterval;
      var sc = pmScreenMeter(rows, meter, pmRow);
      var items = sc.items;
      var newest = items.length ? items[items.length - 1] : null;
      var accepted = null;
      for (var j = items.length - 1; j >= 0; j--) if (!items[j].suspect) { accepted = items[j]; break; }
      out.current[meter] = accepted ? accepted.value : null;
      var baseItem = null;
      if (pmRow) for (var b = 0; b < items.length; b++) if (items[b].row === pmRow) { baseItem = items[b]; break; }
      if (!baseItem && sc.keepItem) baseItem = sc.keepItem;
      var flag = function (it, where) {
        out.suspect.push(pmSuspectEntry(meter, where, it, items, newest, baseItem, pmRow, sc, interval, nowMs));
      };
      for (var s = 0; s < items.length; s++) {
        if (items[s].suspect && items[s] !== newest && items[s] !== baseItem) out.suspectIgnored += 1;
      }
      var d;
      if (!newest) {
        d = { known: false, why: 'no reading on file' };
      } else if (newest.suspect) {
        flag(newest, newest === baseItem ? 'last_pm' : 'latest');
        d = { known: false, suspect: true, current: newest.value, why: 'the latest ' + meter + ' reading (' + pmFmt(newest.value) + ') looks mistyped' };
      } else if (!pmRow) {
        d = { known: false, why: 'no PM baseline', current: newest.value };
      } else if (baseItem && baseItem.suspect) {
        flag(baseItem, 'last_pm');
        d = { known: false, suspect: true, current: newest.value, atLastPm: baseItem.value, why: 'the ' + meter + ' logged at the last PM (' + pmFmt(baseItem.value) + ') looks mistyped' };
      } else if (!baseItem && pmNum(pmRow[meter]) !== null && sc.restarted) {
        d = { known: false, why: 'the last PM was logged before this meter was replaced', current: newest.value, atLastPm: pmNum(pmRow[meter]) };
      } else if (!baseItem && pmNum(pmRow[meter]) === null) {
        d = { known: false, why: 'the last PM has no reading for this meter', current: newest.value };
      } else {
        // (Unreachable for a PM older than the screened window: sc.keepItem screens it.)
        if (!baseItem) baseItem = { value: pmNum(pmRow[meter]), suspect: false };
        var since = newest.value - baseItem.value;
        var tol = meter === 'miles' ? PM_RULES.milesBackTolerance : PM_RULES.hoursBackTolerance;
        if (since < -tol) {
          d = { known: false, why: 'the latest reading is lower than at the last PM', current: newest.value, atLastPm: baseItem.value };
        } else {
          if (since < 0) since = 0;
          d = { known: true, current: newest.value, atLastPm: baseItem.value, sinceLastPm: since, interval: interval, remaining: interval - since };
        }
      }
      dims[meter] = d;
    }
    out.miles = dims.miles;
    out.hours = dims.hours;
    var m = dims.miles;
    var h = dims.hours;
    var fx = function (n) { return Number(n).toFixed(0); };
    var anyReading = out.current.miles !== null || out.current.hours !== null || out.suspect.length > 0;
    if (!anyReading && !rows.some(function (x) { return pmNum(x && x.miles) !== null || pmNum(x && x.hours) !== null; })) {
      out.status = 'unknown'; out.label = 'No meters recorded'; out.reason = 'no meter readings recorded';
      return out;
    }
    if (!pmRow) {
      out.status = 'unknown'; out.label = 'PM not set up (no PM logged yet)'; out.reason = 'no PM baseline recorded';
      return out;
    }
    var fr = [];
    if (m.known && m.interval > 0) fr.push(m.remaining / m.interval);
    if (h.known && h.interval > 0) fr.push(h.remaining / h.interval);
    if (fr.length) out.urgency = Math.min.apply(null, fr);
    var only = m.known && h.known ? '' : (m.known ? ' (hours not compared)' : (h.known ? ' (miles not compared)' : ''));
    var overM = m.known && m.remaining <= 0;
    var overH = h.known && h.remaining <= 0;
    if (overM || overH) {
      out.status = 'overdue';
      out.label = 'PM OVERDUE' + (overM ? ' (' + fx(Math.abs(m.remaining)) + ' mi over)' : ' (' + fx(Math.abs(h.remaining)) + ' hrs over)') + only;
      return out;
    }
    var soonM = m.known && m.remaining <= m.interval * PM_RULES.dueSoonMilesFraction;
    var soonH = h.known && h.remaining <= PM_RULES.dueSoonHours;
    var both = m.known && h.known;
    var left = both ? fx(m.remaining) + ' mi / ' + fx(h.remaining) + ' hrs' : (m.known ? fx(m.remaining) + ' mi' : (h.known ? fx(h.remaining) + ' hrs' : ''));
    if (soonM || soonH) {
      out.status = 'due_soon';
      out.label = 'PM due in ' + left + only;
      return out;
    }
    if (out.suspect.length) {
      var f = out.suspect[0];
      out.status = 'check_reading';
      out.label = f.where === 'last_pm'
        ? 'Check the last PM: ' + pmFmt(f.value) + (f.meter === 'miles' ? ' mi' : ' hrs') + ' looks mistyped'
        : 'Check ' + f.meter + ' reading: ' + pmFmt(f.value) + ' looks mistyped';
      out.reason = 'a meter reading looks mistyped';
      return out;
    }
    if (!m.known && !h.known) {
      out.status = 'unknown'; out.label = 'PM unknown (readings do not compare to the last PM)'; out.reason = 'no meter can be compared with the last PM';
      return out;
    }
    out.status = 'ok';
    out.label = 'PM in ' + left + only;
    return out;
  }

  // ---------------------------------------------------------------------------
  // TASK-9898 follow-up (Chris 2026-10-16, "meter-review-7d"; COD amendments) —
  // when a reading that looks mistyped puts a truck in Needs Attention. ONE rule
  // for the Maintenance screen, the partner summary and the connector:
  //   - no meter compares to the last PM ("PM can't be checked")          -> now;
  //   - the truck would be PM-OVERDUE if the reading is right AND the
  //     reading is PLAUSIBLE (no more than milesPerDay / hoursPerDay x the
  //     days from the last believable reading to now)                     -> now;
  //     an absurd spike only carries the line, it stays in the strip;
  //   - nobody has dealt with it for PM_REVIEW_DAYS calendar days on the
  //     company clock, counted from the row's SERVER createdAt (a writer-set
  //     reading date can be backdated or future-dated). A row with no
  //     createdAt counts as past the 7 days. A newer typo in the same unresolved
  //     run does not restart the clock (the run's EARLIEST createdAt counts).
  // Otherwise it waits in the readings strip. Deterministic: now / today are
  // inputs, nothing is stored, no timer runs. A SAVED newer believable reading,
  // a saved Re-log PM, or "It's right" (meterConfirmed) clears the suspect in
  // pmStatusFor itself; a Fix / Re-log form that is cancelled changes nothing.
  var PM_REVIEW_DAYS = 7; // fixed, not a setting (Chris 2026-10-16)

  var _pmDayFmt = {};
  /** 'YYYY-MM-DD' of `ms` on `timeZone`'s wall clock (unusable zone -> America/Chicago). */
  function pmDayKey(ms, timeZone) {
    if (ms === null || ms === undefined || !isFinite(ms) || ms <= 0) return null;
    var tz = timeZone || 'America/Chicago';
    var fmt = _pmDayFmt[tz];
    if (!fmt) {
      try {
        fmt = new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' });
      } catch (e) {
        return tz === 'America/Chicago' ? null : pmDayKey(ms, 'America/Chicago');
      }
      _pmDayFmt[tz] = fmt;
    }
    var p = {};
    fmt.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
    return p.year + '-' + p.month + '-' + p.day;
  }

  /** Whole calendar days from day key `a` to day key `b` (null if either is not YYYY-MM-DD). */
  function pmDaysBetween(a, b) {
    var re = /^(\d{4})-(\d{2})-(\d{2})$/;
    var x = re.exec(String(a || ''));
    var y = re.exec(String(b || ''));
    if (!x || !y) return null;
    return Math.round((Date.UTC(+y[1], +y[2] - 1, +y[3]) - Date.UTC(+x[1], +x[2] - 1, +x[3])) / PM_DAY_MS);
  }

  /** Epoch ms of a row's server `createdAt` (0 = none). */
  function pmCreatedMs(row) {
    return row && row.createdAt ? pmEntryTimeMs({ ts: row.createdAt }) : 0;
  }

  /** A reading looks mistyped AND no meter compares to the last PM: the PM itself can't be checked. */
  function pmUncheckable(d) {
    return !!(d && d.status === 'check_reading'
      && !(d.miles && d.miles.known) && !(d.hours && d.hours.known));
  }

  // One flagged suspect reading (pmStatusFor's `suspect[]` entry), plus:
  //   clockMs   — when its review clock started (earliest server createdAt of the
  //               unresolved run; null = a row with no createdAt -> due now);
  //   ifRight   — { sinceLastPm, remaining, overdue } on this meter if the reading
  //               is right, against the same last PM (null when there is nothing
  //               to compare it with);
  //   plausible — no more than the meter can run from the last believable
  //               reading to now (a ceiling reading never is).
  function pmSuspectEntry(meter, where, it, items, newest, baseItem, pmRow, sc, interval, nowMs) {
    var R = PM_RULES;
    var e = { meter: meter, where: where, value: it.value, atMs: it.atMs || null, kind: it.kind, against: it.against, rowId: (it.row && it.row.id) || null };
    // Clock: the PM row itself, or the tail run of suspect readings ending at the newest.
    var run = [];
    if (where === 'last_pm') run.push(it);
    else for (var k = items.length - 1; k >= 0 && items[k].suspect; k--) { if (items[k] !== baseItem) run.push(items[k]); }
    if (!run.length) run.push(it);
    var clock = Infinity;
    for (var r = 0; r < run.length; r++) {
      var c = pmCreatedMs(run[r].row);
      // No createdAt, or one in the future (a client can set it until the rules
      // pin it to request.time): no usable clock -> due now (COD 2026-10-16).
      if (!c || c > nowMs + 3600000) { clock = null; break; }
      if (c < clock) clock = c;
    }
    // The run fills the whole screened window (pmScreenMeter keeps the newest
    // screenMax readings): its start may be older than the window -> due now.
    if (where !== 'last_pm' && k < 0 && items.length >= R.screenMax) clock = null;
    e.clockMs = clock === Infinity ? null : clock;
    // The PM both ways: the status is the PM without this reading; here, with it.
    var since = null;
    if (where === 'last_pm') {
      if (newest && newest !== it && !newest.suspect) since = newest.value - it.value;
    } else {
      var base = null;
      if (baseItem && !baseItem.suspect && baseItem !== it) base = baseItem.value;
      else if (!baseItem && pmRow && pmNum(pmRow[meter]) !== null && !sc.restarted) base = pmNum(pmRow[meter]);
      if (base !== null) since = it.value - base;
    }
    // A reading past what any vehicle reads can never be right (pmScreenMeter ignores a confirm on it).
    if (since !== null && interval > 0 && it.kind !== 'ceiling') {
      var used = Math.max(0, since);
      e.ifRight = { sinceLastPm: used, remaining: interval - used, overdue: interval - used <= 0 };
    } else {
      e.ifRight = null;
    }
    var plausible = false;
    if (it.kind !== 'ceiling' && it.against && it.against.atMs > 0 && nowMs > 0) {
      if (it.against.atMs > nowMs + 3600000) {
        plausible = true; // a future-dated "last believable" reading cannot bound it: fail toward attention
      } else {
        var days = Math.max(0, (nowMs - it.against.atMs) / PM_DAY_MS);
        var cap = (meter === 'miles' ? R.milesPerDay : R.hoursPerDay) * days;
        plausible = it.value - it.against.value <= cap;
      }
    }
    e.plausible = plausible;
    return e;
  }

  /**
   * The review state of a vehicle's suspect readings, and whether its PM puts it
   * in Needs Attention. pmStatusFor attaches it as `review`.
   * @param d     a pmStatusFor answer
   * @param opts  { timeZone (company zone, default America/Chicago), todayKey ('YYYY-MM-DD') | nowMs }
   * Returns {
   *   attention, why: 'overdue'|'due_soon'|'uncheckable'|'overdue_if_right'|'unreviewed'|null,
   *   uncheckable, overdueIfRight, unreviewed, reviewDays,
   *   readings: [{ rowId, meter, where, clockDay, daysUnreviewed, unreviewed,
   *                overdueIfRight (show the line), plausible, attentionNow }]   (same order as d.suspect)
   * }
   */
  function pmSuspectReview(d, opts) {
    var o = opts || {};
    var nowMs = o.nowMs !== undefined && o.nowMs !== null ? o.nowMs : Date.now();
    var today = o.todayKey || pmDayKey(nowMs, o.timeZone);
    var st = d && d.status;
    var out = { attention: false, why: null, uncheckable: pmUncheckable(d), overdueIfRight: false, unreviewed: false, reviewDays: PM_REVIEW_DAYS, readings: [] };
    var sus = (d && d.suspect) || [];
    for (var i = 0; i < sus.length; i++) {
      var sx = sus[i];
      var clockDay = pmDayKey(sx.clockMs, o.timeZone);
      var age = clockDay ? pmDaysBetween(clockDay, today) : null;
      var stale = age === null || age >= PM_REVIEW_DAYS;
      var line = !!(sx.ifRight && sx.ifRight.overdue) && st !== 'overdue';
      var now = line && !!sx.plausible;
      if (now) out.overdueIfRight = true;
      if (stale) out.unreviewed = true;
      out.readings.push({ rowId: sx.rowId || null, meter: sx.meter, where: sx.where, clockDay: clockDay, daysUnreviewed: age, unreviewed: stale, overdueIfRight: line, plausible: !!sx.plausible, attentionNow: now || stale });
    }
    if (st === 'overdue') out.why = 'overdue';
    else if (st === 'due_soon') out.why = 'due_soon';
    else if (out.uncheckable) out.why = 'uncheckable';
    else if (out.overdueIfRight) out.why = 'overdue_if_right';
    else if (out.unreviewed) out.why = 'unreviewed';
    out.attention = out.why !== null;
    return out;
  }

  /** 'YYYY-MM-DD' + n days. */
  function pmAddDays(key, n) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(key || ''));
    if (!m) return null;
    return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3] + n)).toISOString().slice(0, 10);
  }

  /**
   * One plain line about ONE suspect reading's review (the readings strip row, the
   * connector), or '' — e.g. "overdue if this reading is right · not reviewed in 9 days".
   * `r` = an entry of d.review.readings; `fmtDay` (optional) formats a 'YYYY-MM-DD'
   * key for display (the app passes "Oct 22"; the connector keeps the key).
   */
  function pmReviewLine(r, fmtDay) {
    if (!r) return '';
    var out = [];
    if (r.overdueIfRight) out.push('overdue if this reading is right');
    if (r.unreviewed) out.push(r.daysUnreviewed === null ? 'not reviewed in ' + PM_REVIEW_DAYS + '+ days' : 'not reviewed in ' + r.daysUnreviewed + ' days');
    else if (r.clockDay && !r.attentionNow) {
      var back = pmAddDays(r.clockDay, PM_REVIEW_DAYS);
      out.push('back in Needs Attention ' + (typeof fmtDay === 'function' ? fmtDay(back) : back) + ' if not reviewed');
    }
    return out.join(' · ');
  }

  /** The review lines of every suspect reading on a pmStatusFor answer, joined ('' when none). */
  function pmReviewNote(d) {
    var rs = (d && d.review && d.review.readings) || [];
    var seen = {};
    var out = [];
    for (var i = 0; i < rs.length; i++) {
      var l = pmReviewLine(rs[i]);
      if (l && !seen[l]) { seen[l] = true; out.push(l); }
    }
    return out.join('; ');
  }

  window.PmStatus = Object.freeze({
    BUILTIN_INTERVALS: PM_BUILTIN_INTERVALS,
    RULES: PM_RULES,
    REVIEW_DAYS: PM_REVIEW_DAYS,
    pmNum: pmNum,
    pmEntryTimeMs: pmEntryTimeMs,
    pmMergeIntervals: pmMergeIntervals,
    pmResolveIntervals: pmResolveIntervals,
    pmRowsForVehicle: pmRowsForVehicle,
    pmScreenMeter: pmScreenMeter,
    pmCheckReading: pmCheckReading,
    pmProblemText: pmProblemText,
    pmStatusFor: pmStatusFor,
    pmFmt: pmFmt,
    pmDayKey: pmDayKey,
    pmDaysBetween: pmDaysBetween,
    pmUncheckable: pmUncheckable,
    pmSuspectReview: pmSuspectReview,
    pmCreatedMs: pmCreatedMs,
    pmAddDays: pmAddDays,
    pmReviewLine: pmReviewLine,
    pmReviewNote: pmReviewNote
  });
})();
